/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type SplitPositionInfo = {
  liquidity: bigint;
  feeA: bigint;
  feeB: bigint;
  reward0: bigint;
  reward1: bigint;
};

export type SplitPositionInfoArgs = {
  liquidity: number | bigint;
  feeA: number | bigint;
  feeB: number | bigint;
  reward0: number | bigint;
  reward1: number | bigint;
};

export function getSplitPositionInfoEncoder(): FixedSizeEncoder<SplitPositionInfoArgs> {
  return getStructEncoder([
    ["liquidity", getU128Encoder()],
    ["feeA", getU64Encoder()],
    ["feeB", getU64Encoder()],
    ["reward0", getU64Encoder()],
    ["reward1", getU64Encoder()],
  ]);
}

export function getSplitPositionInfoDecoder(): FixedSizeDecoder<SplitPositionInfo> {
  return getStructDecoder([
    ["liquidity", getU128Decoder()],
    ["feeA", getU64Decoder()],
    ["feeB", getU64Decoder()],
    ["reward0", getU64Decoder()],
    ["reward1", getU64Decoder()],
  ]);
}

export function getSplitPositionInfoCodec(): FixedSizeCodec<
  SplitPositionInfoArgs,
  SplitPositionInfo
> {
  return combineCodec(
    getSplitPositionInfoEncoder(),
    getSplitPositionInfoDecoder(),
  );
}
